<template>
  <div style="100%;height: 100%;display:flex;flex-direction: column;">
    <div style="display:flex;justify-content:center;flex-direction: column;width:100%;height: 90%;align-items: center;">
      <img src="../../assets/uoofox/logo.png" :width="imgWAndH" :height="imgWAndH"/>
      <div class="download1">
        <span :style="style">白小狐</span>
        <span :style="style2">8.6分 3万次下载 23.4MB</span>
      </div>
      <a class="download2" :style="style3" href="itms-apps://itunes.apple.com/cn/app/id1636474942?mt=8">
        打开苹果应用平台下载
      </a>
      <a class="download2" :style="style3" href="https://www.ioofox.com/download/uoofox.apk">
        通过第三方浏览器下载
      </a>
      <span :style="style5">如无法正常下载，请从右上角菜单中选择--在浏览器中打开</span>
    </div>
    <div class="download3" :style="style4">
      <p> Copyright 2019 - 2029 | All Rights Reserved IOOFOX 深圳市云方程数据技术有限公司 | <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2022061985号</a></p>
    </div>
  </div>
</template>

<script>
export default {
  name: "downloadPage",
  mounted: function () {
  },
  created(){
    let windowWidth = document.documentElement.clientWidth  //实时屏幕宽度
    let windowHeight = document.documentElement.clientHeight   //实时屏幕高度
    this.imgWAndH = (windowHeight * 0.2) + 'px';
    this.style = {
      "font-size": (windowHeight * 0.03) + 'px',
      "padding" : '20px 0 20px 0',
    }
    this.style2 = {
      "font-size": (windowHeight * 0.02) + 'px',
    }
    this.style3 = {
      "font-size": (windowHeight * 0.02) + 'px',
      "width": (windowWidth * 0.6) + 'px',
      "height": (windowHeight * 0.06) + 'px',
      "line-height": (windowHeight * 0.05) + 'px',
      "margin-top": (windowHeight * 0.1) + 'px',
    }
    this.style4 = {
      "margin-top": (windowHeight * 0.05) + 'px',
      "height": (windowHeight * 0.05) + 'px',
      "line-height": (windowHeight * 0.05) + 'px',
    }
    this.style5 = {
      "width": (windowWidth * 0.6) + 'px',
      "font-size": (windowHeight * 0.02) + 'px',
      "margin-top": (windowHeight * 0.05) + 'px',
      "text-align": 'center',
    }

  },
  methods: {
    
  },
  data() {
    return {
      imgWAndH: '',
      style: {
        "font-size": '10px',
      },
      style2: {
        "font-size": '10px',
      },
      style3: {
      },
      style4: {
      },
      style5: {
      },
    };
  },
};
</script>

<style>
.download1{
  display: flex;
  flex-direction: column;
  text-align: center;
}
.download2{
  text-decoration: none;
  display: block;
  text-align: center;
  background-color: #6495ED;
  border-radius: 20px;
  color: white;
}
.download3{
  text-align: center;
  width: 100%;
  background-color: black;
  display: table-cell;
  color: #ffffff;
  font-size: 10px;
}
.download3 a{
  text-decoration: none;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/download/download.vue